import { render, staticRenderFns } from "./BadgePositioning.vue?vue&type=template&id=ed1d5c34"
import script from "./BadgePositioning.vue?vue&type=script&lang=js"
export * from "./BadgePositioning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports